import { useState, useCallback, type ReactNode } from "react";
import {
  ChatOverlayContext,
  type ChatOverlayContextValue,
  type ComposeToChildPayload,
} from "@/contexts/use-chat-overlay";

export function ChatOverlayProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [composeToChildPayload, setComposeToChildPayload] = useState<ComposeToChildPayload | null>(null);

  const openChat = useCallback(() => setIsOpen(true), []);
  const closeChat = useCallback(() => setIsOpen(false), []);
  const toggleChat = useCallback(() => setIsOpen((prev) => !prev), []);

  const openComposeToChild = useCallback((payload: ComposeToChildPayload) => {
    setComposeToChildPayload(payload);
    setIsOpen(true);
  }, []);

  const clearComposePayload = useCallback(() => setComposeToChildPayload(null), []);

  const value: ChatOverlayContextValue = {
    isOpen,
    openChat,
    closeChat,
    toggleChat,
    composeToChildPayload,
    openComposeToChild,
    clearComposePayload,
  };

  return <ChatOverlayContext.Provider value={value}>{children}</ChatOverlayContext.Provider>;
}
